import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  Card,
  Box,
  TextField,
} from "@mui/material";
import { getDatabase, ref, get, update, remove } from "firebase/database";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { ToastContainer, toast } from "react-toastify";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import EmptyData from "../../components/EmptyData";
import { useSelector } from "react-redux";
import ButtonContainer from "../../Utils/approvedRejectDeleteButton.";
import ImageModal from "components/ImageModal";
import GoogleMapModal from "../../DialogBox/googlemap";
import staticmap from "../../assets/images/map.png";
import DetailModal from "Utils/DetailModal";

const RSAApplication = () => {
  const getUserState = useSelector((state) => state?.data?.getUserState);
  const [allData, setAllData] = useState([]);
  const [checkSuperAdmin, setCheckSuperAdmin] = useState(null);
  const [adminState, setAdminState] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [onClickImageData, setOnClickImageData] = useState("");
  const [openMap, setOpenMap] = useState(false);
  const [mapMarkers, setMapMarkers] = useState([]);
  const [userPath, setUserPath] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("All");

  const [selectedPost, setSelectedPost] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

  const navigate = useNavigate();

  const handleImageClick = (url) => {
    setIsModalOpen(true);
    setOnClickImageData(url);
  };

  const handleView = (post) => {
    setSelectedPost(post);
    setIsDetailModalOpen(true);
  };

  const closeDetailModal = () => {
    setSelectedPost(null);
    setIsDetailModalOpen(false);
  };

  const getData = () => {
    const curruntAdminData = JSON.parse(localStorage.getItem("user"));
    const getAdminState = curruntAdminData?.state;
    const useradmin = curruntAdminData?.superAdmin;

    setCheckSuperAdmin(useradmin);
    setAdminState(getAdminState);

    const db = getDatabase();
    const usersRef = ref(db, "users");

    get(usersRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const usersData = snapshot.val();
          const mergedData = [];

          Object.entries(usersData).forEach(([userId, userDetails]) => {
            const shareLocation = userDetails?.security_agents || {};

            Object.entries(shareLocation).forEach(([locationId, locationData]) => {
              const postState = locationData?.state || "";

              const canAccess =
                useradmin && (getUserState === "" || getUserState === "All State")
                  ? true
                  : useradmin
                  ? postState === getUserState
                  : postState === getAdminState;

              if (!canAccess) return;

              mergedData.push({
                id: locationId,
                ...locationData,
                user: userDetails,
                userId,
                applicationReviewed: locationData?.applicationReviewed || "Pending",
                adminVerified: locationData?.adminVerified || "Pending",
              });
            });
          });

          //  console.log("Merged RSA Data:", mergedData);
          setAllData(mergedData);
        } else {
          setAllData([]);
        }
      })
      .catch((error) => {
        //  console.error("Error fetching data:", error);
        setAllData([]);
      });
  };

  const handleApproveReject = (post, action) => {
    const db = getDatabase();
    const path = `users/${post.userId}/security_agents/${post.id}`;

    const updatedData = {
      adminVerified: action === "approved" ? "Approved" : "Rejected",
      applicationReviewed: "Reviewed",
    };

    update(ref(db, path), updatedData)
      .then(() => {
        toast.success(`Post ${action} successfully.`);
        getData();
      })
      .catch((error) => {
        //  console.error("Error updating post status:", error);
      });
  };

  const handleDelete = (post) => {
    const db = getDatabase();
    const path = `users/${post.userId}/security_agents/${post.id}`;

    remove(ref(db, path))
      .then(() => {
        toast.success("Post deleted successfully.");
        getData();
      })
      .catch((error) => {
        //  console.error("Error deleting post:", error);
      });
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/authentication/sign-in");
    }
    getData();
  }, [getUserState]);

  const getRowColor = (status) => {
    switch (status) {
      case "Approved":
        return "lightgreen";
      case "Rejected":
        return "lightcoral";
      default:
        return "lightyellow";
    }
  };

  const filteredData = allData.filter((item) => {
    const term = searchTerm.toLowerCase();
    const matchesSearch =
      item.location?.toLowerCase().includes(term) ||
      item.mobile?.toLowerCase().includes(term) ||
      item.fullName?.toLowerCase().includes(term) ||
      item.email?.toLowerCase().includes(term);

    const matchesStatus = selectedStatus === "All" || item.adminVerified === selectedStatus;

    return matchesSearch && matchesStatus;
  });

  const onClose = () => {
    setIsModalOpen(false);
  };

  return (
    <DashboardLayout>
      <MDBox pt={9} pb={3}>
        <Box display="flex" justifyContent="flex-end" alignItems="center" mb={5} px={2} gap={2}>
          <TextField
            label="Search by name, location or phone"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 300 }}
          />

          <TextField
            label="Status"
            select
            size="small"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            sx={{ width: 150 }}
            SelectProps={{
              native: true,
            }}
          >
            <option value="All">All</option>
            <option value="Approved">Approved</option>
            <option value="Pending">Pending</option>
            <option value="Rejected">Rejected</option>
          </TextField>
        </Box>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ textAlign: "center" }}
              >
                <ToastContainer />
                <MDTypography variant="h6" color="white">
                  {checkSuperAdmin
                    ? getUserState === ""
                      ? "ALL STATE"
                      : `${getUserState?.toUpperCase()} STATE`
                    : `${adminState?.toUpperCase()} STATE`}{" "}
                  Remote Security Agent (RSA) Application
                </MDTypography>
              </MDBox>

              {filteredData.length > 0 ? (
                <MDBox>
                  <TableContainer component={Paper}>
                    <Table sx={{ "& td, & th": { fontSize: "14px", padding: "8px" } }}>
                      <TableBody>
                        <TableRow>
                          {[
                            "SR",
                            "Name",
                            "Email",
                            "Gender",
                            "DOB",
                            "State",
                            "Phone",

                            "View",
                            "Application Reviewed",
                            "Admin Verified",
                            "Actions",
                          ].map((label) => (
                            <TableCell key={label} align="center" sx={{ fontWeight: "bold" }}>
                              {label}
                            </TableCell>
                          ))}
                        </TableRow>

                        {filteredData.map((post, index) => (
                          <TableRow
                            key={post.id}
                            sx={{ backgroundColor: getRowColor(post.adminVerified) }}
                          >
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">{post.fullName || "N/A"}</TableCell>
                            <TableCell align="center">{post.email || "N/A"}</TableCell>
                            <TableCell align="center">{post.gender || "N/A"}</TableCell>
                            <TableCell align="center">{post.dob || "N/A"}</TableCell>
                            <TableCell align="center">{post.state || "N/A"}</TableCell>
                            <TableCell align="center">{post.mobile || "N/A"}</TableCell>

                            <TableCell align="center">
                              <button
                                style={{
                                  padding: "4px 8px",
                                  fontSize: "12px",
                                  borderRadius: 4,
                                  border: "1px solid #1976d2",
                                  backgroundColor: "#1976d2",
                                  color: "white",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleView(post)}
                              >
                                View
                              </button>
                            </TableCell>
                            <TableCell align="center">{post.applicationReviewed}</TableCell>
                            <TableCell align="center">{post.adminVerified}</TableCell>
                            <TableCell align="center">
                              <Box display="flex" gap={1} justifyContent="center" flexWrap="wrap">
                                <ButtonContainer
                                  notification={post}
                                  handleApproveReject={handleApproveReject}
                                  handleDelete={handleDelete}
                                />
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </MDBox>
              ) : (
                <EmptyData />
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <ImageModal onClickImageData={onClickImageData} onClose={onClose} isModalOpen={isModalOpen} />

      <GoogleMapModal
        open={openMap}
        onClose={() => setOpenMap(false)}
        markerList={mapMarkers}
        userLocation={userPath}
      />

      <DetailModal open={isDetailModalOpen} onClose={closeDetailModal} data={selectedPost} />
    </DashboardLayout>
  );
};

export default RSAApplication;
